import { Dialog, DialogContent, DialogTitle, Grid, MenuItem, Typography } from '@mui/material'
import { useCallback, useEffect, useState } from 'react'

import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import ClearIcon from '@mui/icons-material/Clear';
import DepartmentApi from '../../api/departments/departments.api';
import { swalError, swalSuccess } from '../../component/notification/swal';
import InputTextField from '../../component/input/inputTextField';
import TableRowCommon from '../../component/table/TableRowCommon';
import { LayoutTitle, LayoutView, TitleText } from '../../component/layout/layoutMainStyle';
import ButtonCustom from '../../component/button/buttonCustom';
import { icons } from '../../constants/images';
import TableCustom from '../../component/table/tableCustom';
import FilterSelect from '../../component/select/filterSelect';

const initStateErrorMessage = {
    DEPARTMENT_NAME: "",
    DEPARTMENT_ADDRESS: "",
    DEPARTMENT_TEL: "",
    DEPARTMENT_FAX: "",
    DEPARTMENT_EMAIL: "",
};
export default function Agencies() {
    const { t } = useTranslation();
    const { profile } = useSelector((state: any) => state.profile)
    const permit = profile?.permission || []
    const [errorMessage, setErrorMessage] = useState<any>(initStateErrorMessage);
    const clearErrorMessage = () => setErrorMessage(initStateErrorMessage);
    const [data, setData] = useState<any>([])
    const [detail, setDetail] = useState<any>({
        departmentName: "",
        departmentAddress: "",
        departmentTel: "",
        departmentFax: "",
        departmentEmail: "",
        departmentStatus: "เปิดใช้งาน",
    })
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(5);
    const [rowCount, setRowCount] = useState<number>(3);
    const [totalPages, setTotalPages] = useState<number>(3);
    const [totalItem, setTotalItem] = useState<number>(60);
    const [create, setCreate] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);

    const [open, setOpen] = useState<boolean>(false);
    const [input, setInput] = useState<any>({
        departmentName: "",
        departmentAddress: "",
        departmentTel: "",
        departmentFax: "",
        departmentEmail: "",
        departmentStatus: "เปิดใช้งาน",
        departmentList: []
    })
    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setDetail({
            departmentName: "",
            departmentAddress: "",
            departmentTel: "",
            departmentFax: "",
            departmentEmail: "",
            departmentStatus: "เปิดใช้งาน",
            departmentList: []
        })
    };
    const loadData = async () => {
        DepartmentApi.getDepartment('1').then((res) => {
            if (res?.data?.success) {
                setInput(res.data.result);
                setData(res.data.result.departmentList)
            }
        });
    }

    useEffect(() => {
        loadData()
    }, [])

    const postData = async (input: any) => {

        if (!input.departmentName)
            return setErrorMessage({
                ...errorMessage,
                ...{ DEPARTMENT_NAME: '' },
            });
        setLoading(true)
       
        if (input?.idDepartment) {
            await DepartmentApi.patchDepartment(input?.idDepartment, input).then((res) => {
                if (res?.data?.success) {
                    loadData()
                    setLoading(false)
                    swalSuccess(t('แก้ไขหน่วยงานสำเร็จ'))
                } else {
                    setLoading(false)
                    swalError(res.data.description || res.data.message);
                }

            }).catch((error: any) => {
                setLoading(false)
                swalError(error.response.data.description || error.response.data.message);
            })
        } else {
            await DepartmentApi.postDepartment(input).then((res) => {
                if (res?.data?.success) {
                    loadData()
                    setLoading(false)
                    swalSuccess(t('สร้างหน่วยงานสำเร็จ'))
                } else {
                    setLoading(false)
                    swalError(res.data.description || res.data.message);
                }

            }).catch((error: any) => {
                setLoading(false)
                swalError(error.response.data.description || error.response.data.message);
            })
        }


    }
    const changeStatus = async (value: string, objData: any) => {
        await DepartmentApi.patchDepartment(objData?.idDepartment, { ...objData, departmentStatus: value }).then((res) => {
            if (res?.data?.success) {
                swalSuccess(t('EMPLOYEES_CREATE.SWAL.EDIT_STATUS_SUCCESS'))
                loadData()
            } else {
                swalError(res.response.data.description || res.response.data.message);

            }

        }).catch((error: any) => {
            swalError(error.response.data.description || error.response.data.message);
        })
    }

    const headCells = [
        {
            id: "no",
            label: 'ลำดับ',
            align: "center",
            colSpan: 1,
            sortable: true,
            width: '58px'
        },
        {
            id: "CreateDate",
            label: 'ข้อมูลหน่วยงาน',
            align: "left",
            colSpan: 1,
            sortable: true
        },
        {
            id: "CreateDate1",
            label: 'สถานะ',
            align: "center",
            colSpan: 1,
            sortable: true
        },
        {
            id: "action",
            disablePadding: false,
            align: "center",
            colSpan: 1,
        },
    ];



    const renderData = (objData: any, index: any) => {
        const { departmentName, departmentStatus, idDepartment } = objData;
        let no = page * pageLimit - pageLimit + index + 1;

        const objRenderData = {
            key: no,
            id: idDepartment,
            obj: objData,
            columns: [
                { option: "TEXT", align: "center", label: no },
                { option: "TEXT", align: "left", label: departmentName },
                {
                    option: "COMPONENT",
                    align: "center",
                    component: (
                        <>
                            <FilterSelect
                                disabled={!permit.find((x: any) => x?.code === 'Department.Edit')?.permit}
                                labelId='' selectId='' style={{
                                    '& .MuiSelect-select': {
                                        backgroundColor: departmentStatus === 'เปิดใช้งาน' ? '#F3FFF6' : '#ffe4e4',
                                        color: departmentStatus === 'เปิดใช้งาน' ? '#2AA63C' : '#ff0000',
                                        margin: '0px 30px 0px 6px',
                                        padding: '5px 0px',
                                    }
                                }} options={[{ value: 'เปิดใช้งาน', name: 'เปิดใช้งาน' }, { value: 'ไม่ใช้งาน', name: 'ไม่ใช้งาน' }].map((x, i) => {
                                    return (
                                        <MenuItem key={i}
                                            value={x.value}
                                            sx={{
                                                backgroundColor: x.value === 'เปิดใช้งาน' ? '#F3FFF6' : '#ffe4e4',
                                                color: x.value === 'เปิดใช้งาน' ? '#2AA63C' : '#ff0000',
                                            }}
                                        >
                                            ● {x.name}
                                        </MenuItem>
                                    )
                                })} value={departmentStatus} onchange={(e: any) =>
                                    // setData((prevData: any) => {
                                    //     const newData = [...prevData];
                                    //     newData[index] = { ...newData[index], departmentStatus: e?.target?.value };
                                    //     return newData;
                                    // })
                                    changeStatus(e.target.value, objData)
                                } />
                        </>
                    )
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    component: (

                        <>{
                            permit.find((x: any) => x?.code === 'Department.Edit')?.permit &&
                            <icons.editTable style={{ cursor: "pointer" }} onClick={() => {
                                setDetail({ ...objData, index: index })
                                handleClickOpen()
                            }} />
                        }</>

                    )
                }
            ],
        }

        return (
            <TableRowCommon
                {...objRenderData}
                ondocumentdetail={() => { }}
            />
        )
    };
    return (
        <LayoutView>
            <LayoutTitle>
                <TitleText>ข้อมูลหน่วยงาน</TitleText>
                {
                    permit.find((x: any) => x?.code === 'Department.Add')?.permit &&
                    <ButtonCustom variant={'outlined'}
                        textButton={'บันทึก'}
                        disabled={loading}
                        onClick={() => { postData(input) }}
                        btnStyle={{
                            '&.MuiButton-outlined': {
                                color: `#fff !important`,
                                border: `2px solid #026735 !important`,
                                borderRadius: "10px !important",
                                backgroundColor: '#026735 !important',
                                '&:hover': {
                                    color: `#fff  !important`,
                                    border: `2px solid #026735 !important`,
                                    backgroundColor: '#026735 !important'
                                },
                            },
                        }} />
                }

            </LayoutTitle>
            <Grid container spacing={1} sx={{ marginBottom: '20px' }}>
                <Grid item xs={12}>
                    <InputTextField heading='ชื่อหน่วยงาน' value={input.departmentName} onchange={(e) => {
                        setInput({ ...input, departmentName: e.target.value })
                        clearErrorMessage();
                    }}
                        helperText={
                            errorMessage.DEPARTMENT_NAME || ''
                        } />
                </Grid>
                <Grid item xs={12}>
                    <InputTextField heading='ที่ตั้ง' value={input.departmentAddress} onchange={(e) => {
                        setInput({ ...input, departmentAddress: e.target.value })
                        clearErrorMessage();
                    }}
                        helperText={
                            errorMessage.DEPARTMENT_ADDRESS || ''
                        } />
                </Grid>
                <Grid item md={4} xs={12}>
                    <InputTextField heading='เบอร์โทรศัพท์' value={input.departmentTel} onchange={(e) => {
                        setInput({ ...input, departmentTel: e.target.value })
                        clearErrorMessage();
                    }}
                        helperText={
                            errorMessage.DEPARTMENT_TEL || ''
                        } />
                </Grid>
                <Grid item md={4} xs={12}>
                    <InputTextField heading='เบอร์โทรสาร' value={input.departmentFax} onchange={(e) => {
                        setInput({ ...input, departmentFax: e.target.value })
                        clearErrorMessage();
                    }}
                        helperText={
                            errorMessage.DEPARTMENT_FAX || ''
                        } />
                </Grid>
                <Grid item md={4} xs={12}>
                    <InputTextField heading='E-Mail' value={input.departmentEmail} onchange={(e) => {
                        setInput({ ...input, departmentEmail: e.target.value })
                        clearErrorMessage();
                    }}
                        helperText={
                            errorMessage.DEPARTMENT_EMAIL || ''
                        } />
                </Grid>
            </Grid>
            <LayoutTitle>
                <TitleText>หน่วยงานภายใต้</TitleText>
                {permit.find((x: any) => x?.code === 'Department.Add')?.permit &&
                    <ButtonCustom variant={'outlined'}
                        startIcon={<icons.circleButton />}
                        textButton={'เพิ่ม'}
                        onClick={() => {
                            setCreate(true)
                            setDetail({ ...detail, index: data?.length })
                            handleClickOpen()
                        }} />
                }

            </LayoutTitle>
            <TableCustom
                headCells={headCells}
                customScroll
                page={page}
                pageLimit={pageLimit}
                sortType={"ASC"}
                sortBy=""
                rowCount={rowCount}
                rowsData={data?.map((d: any, index: any) => {
                    return renderData(d, index);
                })}
                onSort={() => { }}
                setPageLimit={(value: number) => setPageLimit(value)}
                setPage={(value: number) => setPage(value)}
                totalPages={totalPages}
                totalItem={totalItem}
                hidePagination
            />
            <Dialog
                open={open}
                keepMounted
                onClose={handleClose}
                fullWidth
                maxWidth='md'
            >
                <DialogTitle sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <ClearIcon sx={{ cursor: 'pointer', fontSize: "20px" }} onClick={() => {
                        handleClose()
                    }} />
                </DialogTitle>
                <DialogContent sx={{ padding: '32px', gap: '32px', display: 'flex', flexDirection: "column" }}>
                    <div style={{ display: "flex", justifyContent: 'center', width: '100%' }}>
                        <TitleText>ข้อมูลหน่วยงาน</TitleText>
                    </div>
                    <Grid container spacing={1}>

                        <Grid item xs={12}><InputTextField heading='ชื่อหน่วยงาน' value={detail?.departmentName || ''} onchange={(e) => {
                            setDetail({ ...detail, departmentName: e?.target?.value })
                        }} /></Grid>
                        <Grid item xs={12}><InputTextField heading='ที่ตั้ง' value={detail?.departmentAddress || ''} onchange={(e) => {
                            setDetail({ ...detail, departmentAddress: e?.target?.value })
                        }} /></Grid>
                        <Grid item md={6} xs={12}><InputTextField heading='เบอร์โทรศัพท์' value={detail?.departmentTel || ''} onchange={(e) => {
                            setDetail({ ...detail, departmentTel: e?.target?.value })
                        }} /></Grid>
                        <Grid item md={6} xs={12}><InputTextField heading='เบอร์โทรสาร' value={detail?.departmentFax || ''} onchange={(e) => {
                            setDetail({ ...detail, departmentFax: e?.target?.value })
                        }} /></Grid>
                        <Grid item xs={12}><InputTextField heading='อีเมล' value={detail?.departmentEmail || ''} onchange={(e) => {
                            setDetail({ ...detail, departmentEmail: e?.target?.value })
                        }} /></Grid>
                    </Grid>
                    <ButtonCustom textButton={'บันทึก'} onClick={() => {
                        // if (create) {
                        //     setData([...data, detail])
                        // }
                        // setData((prevData: any) => {
                        //     const newData = [...prevData];
                        //     newData[detail.index] = { ...newData[detail.index], ...detail };
                        //     return newData;
                        // })
                        // setCreate(false)
                        postData({...detail, idDepartmentRef: 1})
                        handleClose()
                    }} style={{ margin: "auto" }} />
                </DialogContent>

            </Dialog>
        </LayoutView >
    )
}
